import React from "react";
import ReportDataTable from "./ReportDataTable";

const columns = [
  { label: "S/N", key: "serial", render: (row) => row.serial },
  { label: "Category", key: "category_name" },
  { label: "Menu Item Count", key: "menu_item_count" },
  {
    label: "Total Sale(Rs.)",
    key: "total_sale",
    render: (row) => Number(row.total_sale || 0).toFixed(2),
  },
];

const CategoryReport = ({ rows = [], loading }) => (
  <ReportDataTable
    columns={columns}
    rows={rows.map((row, index) => ({ ...row, serial: index + 1 }))}
    loading={loading}
    emptyMessage="No category report data found."
  />
);

export default CategoryReport;
